var pubsub = require('pubsub');
var gsap = require('gsap');
var swiper = require('swiper');
var classList = require('dom-classlist');


module.exports = function () {
    var news = document.querySelector('.swiper-container-news');

    if(!news) return;

    swiper = new Swiper (news, {
        // Optional parameters
        direction: 'horizontal',
        //	    loop: true,
        slidesPerView:2.3,
        nextButton : news.parentNode.querySelector('.next'),
        prevButton : news.parentNode.querySelector('.prev'),

        // And if we need scrollbar
        //scrollbar: '.swiper-scrollbar',
        breakpoints: {
            // when window width is <= 640px
            640: {
              slidesPerView: 1.2,
            }
        }
    })
}
